import type { DateInput } from 'utils/datetime';
import type { CalendarProps } from 'react-calendar';

export type CalendarTileProps = {
  tileContent?: CalendarProps['tileContent'];
  date: Date;
  isSelected: boolean;
};

export enum NavDirection {
  Next = 'Next',
  Prev = 'Prev',
}

export type NavButtonProps = {
  direction: NavDirection;
  /** toggle to style the calendar as the deprecated core/calendar. do not use this.  */
  styledAsCore?: boolean;
};

export type RangeCalendarProps = {
  /** Disables any dates into the future */
  blockFutureDates?: boolean;
  /** Disables any dates into the past */
  blockPastDates?: boolean;
  /** Custom react node to be displayed in tile */
  tileContent?: CalendarTileProps['tileContent'];
  /** Start date of date range */
  startDate: DateInput;
  /** End date of date range */
  endDate: DateInput;
  /**
   * Callback when date changes.`
   * @param { moment } date: The newly selected date.
   * @returns {void}
   */
  onDatesChange: (newValue: ValidDateRange) => void;
  showNeighboringMonth?: CalendarProps['showNeighboringMonth'];
  /** @deprecated: toggle to style the calendar as the deprecated core/calendar. do not use this.  */
  styledAsCore?: boolean;
  validDateRange?: ValidDateRange;
};

export type SingleDateCalendarProps = {
  /** Disables any dates into the future */
  blockFutureDates?: boolean;
  /** Disables any dates into the past */
  blockPastDates?: boolean;
  /** Custom content to be displayed in tile */
  tileContent?: CalendarTileProps['tileContent'];
  /** Date of calendar */
  date: DateInput;
  /** Callback when date changes. */
  onDateChange: (newValue: Date) => void;
  /** @deprecated: toggle to style the calendar as the deprecated core/calendar. do not use this.  */
  styledAsCore?: boolean;
  validDateRange?: ValidDateRange;
};

/**
 * react-calendar doesn't export the Value that the callback functions (onChange for us) spits out,
 * so we have to type it up ourselves.
 *
 * the following is the result, which is taken directly from the example found on https://github.com/wojtekmaj/react-calendar/blob/main/README.md */
type ValuePiece = Date | null;
export type Value = ValuePiece | [ValuePiece, ValuePiece];

export type ValidDateRange = {
  startDate?: DateInput;
  endDate?: DateInput;
};
